const CACHE_PREFIX = "alraheem:cache:";

type CachedEntry<T> = {
  data: T;
  timestamp: number;
  ttl: number;
};

const isBrowser = typeof window !== "undefined";

export const buildCacheKey = (method: string, endpoint: string, body?: string | null) => {
  const rawKey = `${method}:${endpoint}:${body ?? ""}`;
  return encodeURIComponent(rawKey);
};

export const setCachedResponse = <T>(key: string, data: T, ttl: number) => {
  if (!isBrowser) {
    return;
  }

  try {
    const entry: CachedEntry<T> = {
      data,
      timestamp: Date.now(),
      ttl,
    };
    localStorage.setItem(`${CACHE_PREFIX}${key}`, JSON.stringify(entry));
  } catch (error) {
    console.warn("[offline-cache] Failed to save cache entry", error);
  }
};

export const getCachedResponse = <T>(key: string): T | null => {
  if (!isBrowser) {
    return null;
  }

  try {
    const raw = localStorage.getItem(`${CACHE_PREFIX}${key}`);
    if (!raw) {
      return null;
    }

    const entry = JSON.parse(raw) as CachedEntry<T>;
    if (Date.now() - entry.timestamp > entry.ttl) {
      localStorage.removeItem(`${CACHE_PREFIX}${key}`);
      return null;
    }

    return entry.data;
  } catch (error) {
    console.warn("[offline-cache] Failed to read cache entry", error);
    return null;
  }
};

export const clearCachedResponse = (key: string) => {
  if (!isBrowser) {
    return;
  }

  try {
    localStorage.removeItem(`${CACHE_PREFIX}${key}`);
  } catch (error) {
    console.warn("[offline-cache] Failed to clear cache entry", error);
  }
};

export const clearCacheByPattern = (pattern: string) => {
  if (!isBrowser) {
    return;
  }

  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(CACHE_PREFIX) && key.includes(pattern)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    console.warn("[offline-cache] Failed to clear cache by pattern", error);
  }
};

export const clearAllCache = () => {
  if (!isBrowser) {
    return;
  }

  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(CACHE_PREFIX)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    console.warn("[offline-cache] Failed to clear all cache", error);
  }
};


